module.exports = __webpack_public_path__ + "img/gccare.032a95b6.svg";